export default (theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-between',
        height: 120,
        padding: 16,
        backgroundColor: theme.colors.primary.white,
        borderRadius: 8,
        boxShadow:
            '0 1px 3px 0 rgba(39, 60, 80, 0.2), 0 2px 2px 0 rgba(39, 60, 80, 0.12), 0 0 2px 0 rgba(39, 60, 80, 0.14)',
        overflow: 'hidden',
        '&, & *': {
            boxSizing: 'border-box',
        },
        '&:hover $hoverContent': {
            opacity: 1,
        },
    },
    header: {
        display: 'flex',
        flexFlow: 'row nowrap',
        gap: 8,
        alignItems: 'center',
    },
    icon: {
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.background.jadeT7,
        borderRadius: '50%',
    },
    footer: {
        display: 'grid',
        gap: 8,
        gridTemplateColumns: 'repeat(1fr, 2)',
    },
    progress: {
        gridColumn: '1 / span 2',
    },
    percentage: {
        justifySelf: 'flex-end',
    },
    hoverContent: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: alphaColor(theme.colors.primary.white, 0.9),
        padding: '12px 16px',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-between',
        opacity: 0,
        transition: 'opacity .5s ease',
    },
    hoverContentCTA: {
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-around',
    },
    hoverContentMarkdown: { gap: 4 },
});
import { alphaColor } from '@Sage/ssm-utils';
